import { render, staticRenderFns } from "./ProductSkuAdd.vue?vue&type=template&id=30f9d22c&scoped=true&"
import script from "./ProductSkuAdd.vue?vue&type=script&lang=js&"
export * from "./ProductSkuAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f9d22c",
  null
  
)

export default component.exports